// Thrown when the quote endpoint fails. Carries the server's exact
// insufficient-balance amounts (decimal token amounts, e.g. '1.007') when it
// supplied them, so callers can show the precise shortfall instead of generic
// copy.
export class SwapQuoteError extends Error {
  insufficientBalance?: { requiredAmount: string; availableBalance: string }
  // Stays undefined when the request failed before the server answered.
  errorType?: string
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const toSwapQuoteError = (e: any): SwapQuoteError => {
  const error = new SwapQuoteError('Failed to fetch quote')
  const responseData = e?.response?.data
  if (
    responseData?.splitsErrorCodeString === 'SWAP_QUOTE_ERROR' &&
    typeof responseData?.data?.errorType === 'string'
  ) {
    error.errorType = responseData.data.errorType
  }
  if (
    responseData?.splitsErrorCodeString === 'SWAP_QUOTE_ERROR' &&
    responseData?.data?.errorType === 'InsufficientBalance' &&
    typeof responseData.data.amount === 'string' &&
    typeof responseData.data.balance === 'string'
  ) {
    error.insufficientBalance = {
      requiredAmount: responseData.data.amount,
      availableBalance: responseData.data.balance,
    }
  }
  return error
}
